import { render, staticRenderFns } from "./DropdownAction.vue?vue&type=template&id=a51244ce"
import script from "./DropdownAction.vue?vue&type=script&lang=js"
export * from "./DropdownAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports